import { Message } from 'element-ui'
import request from './request'
const api = {}
const methods = ['post', 'get', 'upload']

methods.forEach(method => {
  api[method] = function (url, params, msg) {
    return new Promise((resolve, reject) => {
      if (method === 'upload') {
        request({ url, method: 'post', data: params, headers: { 'Content-Type': 'multipart/form-data' } }).then((res) => {
          if (msg) {
            Message({
              message: msg + '成功',
              type: 'success',
              showClose: true,
              duration: 3 * 1000
            })
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      } else {
        request[method](url, params, msg).then((res) => {
          if (msg) {
            Message({
              message: msg + '成功',
              type: 'success',
              showClose: true,
              duration: 3 * 1000
            })
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      }
    })
  }

})
console.log(api)

export default api